import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';
import v from 'scss/v';


export default function EbCard(props) {
  const { className, title, actionsInHeader, footerText, actionsInFooter, children, showHeader, showFooter } = props;
  const Card = styled.section`
    width: 100%;
    display: flex;
    flex-direction: column;
    color: inherit;
    border-radius: 0;

    .card-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .card-header .card-title {
      background-color: initial;
      color: inherit;
      padding: 0;
      margin: 0;
      font-size: 18px;
      font-weight: 500;
    }

    .card-header .card-title a {
      color: ${v('$link-color')};
      text-decoration: underline;
    }
    .card-header .card-title a:hover {
      text-decoration: underline;
    }

    .card-footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .card-footer .card-footer-actions-bar {
      display: flex;
      justify-content: flex-end;
    }

  `;

  return (
    <Card className={classnames('card', className)}>
      {
        showHeader &&
        <div className="card-header">
          <div className="card-title">{title}</div>
          <div className="card-header-actions-bar">
            {
              actionsInHeader.map(item =>
                <button
                  className={classnames('card-header-action-button', item.className)}
                  type="button"
                  key={item.id}
                  onClick={item.onClick}
                  eb-test={item.ebTest}
                >
                  { item.text }
                </button>
              )
            }
          </div>
        </div>
      }
      <div className="card-content">
        { children }
      </div>
      {
        showFooter &&
        <div className="card-footer">
          <div className="card-footer-text">{footerText}</div>
          <div className="card-footer-actions-bar">
            {
              actionsInFooter.map(item => <button className={classnames('card-footer-action-button ml-2', item.className)} type="button" key={item.id} onClick={item.onClick}>{ item.text }</button>)
            }
          </div>
        </div>
      }
    </Card>
  );
}

EbCard.propTypes = {
  title: PropTypes.string.isRequired,
  actionsInHeader: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    ebTest: PropTypes.string
  })),
  footerText: PropTypes.string,
  actionsInFooter: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  })),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
};

EbCard.defaultProps = {
  actionsInHeader: [],
  actionsInFooter: [],
  footerText: '',
  children: '',
  showHeader: true,
  showFooter: true,
};
